import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
// Font Mulish TỰ LƯU TRỮ (gói npm, giấy phép OFL) — không gọi Google Fonts: app nội bộ phải chạy được cả
// khi mạng ngoài chập chờn, và không gửi địa chỉ IP của nhân viên cho bên thứ ba. Font biến thiên: một
// file cho mọi độ đậm 200–1000; trình duyệt chỉ tải các khối ký tự thật sự dùng (latin, vietnamese).
import '@fontsource-variable/mulish';
import '@fontsource-variable/mulish/wght-italic.css';
import './app/global.css';
import { startPwa } from './stores/pwa-store';

// Trước khi React vẽ: lời mời cài của trình duyệt chỉ bắn một lần, rất sớm.
startPwa();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
